import { Instance } from 'mobx-state-tree';
import { PlanningActionDtoModelBase } from './PlanningActionDtoModel.base';

/* The TypeScript type of an instance of PlanningActionDtoModel */
export interface PlanningActionDtoModelType extends Instance<typeof PlanningActionDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionDtoModel */
export { selectFromPlanningActionDto, planningActionDtoModelPrimitives, PlanningActionDtoModelSelector } from './PlanningActionDtoModel.base';

/**
 * PlanningActionDtoModel
 */
export const PlanningActionDtoModel = PlanningActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
